import { render, staticRenderFns } from "./ReviewInvestigator.vue?vue&type=template&id=300e8ea6"
import script from "./ReviewInvestigator.vue?vue&type=script&lang=js"
export * from "./ReviewInvestigator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports